import { FontWeight, Heading, LiliButton, LiliButtonType, Text } from '@lili/lili-frontend-common';
import { Trans, useTranslation } from 'react-i18next';
import { DnbTrustRow } from './DnbTrustRow';

export const DNB_INTRO_GET_STARTED_TEST_ID = 'dnb-embedded-intro-get-started';

interface DnbIntroCopyProps {
  variant: 'mobile' | 'desktop';
  className?: string;
}

export const DnbIntroCopy = ({ variant, className = '' }: DnbIntroCopyProps) => {
  const HeadingTag = variant === 'mobile' ? Heading.H5 : Heading.H1;

  return (
    <div
      className={`flex flex-col ${
        variant === 'mobile' ? 'gap-[4px] text-center' : 'gap-[12px]'
      } ${className}`}>
      <HeadingTag
        fontWeight={FontWeight.SEMIBOLD}
        className={variant === 'mobile' ? undefined : 'tracking-[-1px] leading-[56px]'}>
        <Trans
          i18nKey='pages.dnbEmbeddedIntro.headline'
          components={{ blue: <span className='text-text-brand-primary' /> }}
        />
      </HeadingTag>
      <Text.H9 className='text-text-main-primary'>
        <Trans i18nKey='pages.dnbEmbeddedIntro.subheadline' components={{ sup: <sup /> }} />
      </Text.H9>
    </div>
  );
};

interface DnbIntroCtaProps {
  // `tablet` uses the desktop copy/CTA sizing (14px bonus, 24px stack gap) but the
  // compact mobile trust row (Trustpilot micro badge, no FDIC shield icon).
  variant: 'mobile' | 'tablet' | 'desktop';
  buttonId: string;
  onGetStarted: () => void;
  className?: string;
}

export const DnbIntroCta = ({
  variant,
  buttonId,
  onGetStarted,
  className = '',
}: DnbIntroCtaProps) => {
  const { t } = useTranslation();
  const WelcomeBonus = variant === 'mobile' ? Text.H12 : Text.H10;

  return (
    <div
      className={`flex flex-col items-center ${
        variant === 'mobile' ? 'gap-[16px]' : 'gap-[24px]'
      } ${className}`}>
      <WelcomeBonus className='text-center'>
        <Trans
          i18nKey='pages.dnbEmbeddedIntro.welcomeBonus'
          components={{ bold: <span className='font-semibold' />, sup: <sup /> }}
        />
      </WelcomeBonus>
      <LiliButton
        id={buttonId}
        data-testid={DNB_INTRO_GET_STARTED_TEST_ID}
        className='w-full'
        type={LiliButtonType.PRIMARY}
        title={t('pages.dnbEmbeddedIntro.getStarted')}
        onClick={onGetStarted}
      />
      <DnbTrustRow variant={variant === 'desktop' ? 'desktop' : 'mobile'} />
    </div>
  );
};
